module.exports = __webpack_public_path__ + "static/media/eth.c7b56ff7.png";